// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.admanagement.listingoperations.RentalManagerUserClaimableListingsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AllowedFeedDto,
  ClaimCustomerListingsRequestDto,
  ClaimCustomerListingsResponseDto,
  ClaimFeedCompanyResponseDto,
  CompanyPropertyClaimingDto,
  CustomerClaimedFeedCompanyDto,
  CustomerClaimingEmailMessageInfoDto,
  CustomerHasNewPropertiesToClaimResponseDto,
  ReleaseCustomerListingsRequestDto,
  ReleaseCustomerListingsResponseDto,
  SalesProUserInfoDto,
} from '../..';

interface ClaimFeedCompanyParams {
  feedCompanyId: string;
  feedId: string;
}
interface GetClaimablePropertiesParams {
  pageSize?: number;
  startUnitId?: number;
  unitId?: number;
}
interface GetClaimablePropertiesFilteredParams {
  searchValue: string;
}
interface ReleaseFeedCompanyClaimParams {
  feedCompanyId: string;
  feedId: string;
}

export const RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Path =
  '/api/web/v1/users/adManagement/listingOperations/claimCustomerListings';

/**
 * Claim customer Listing
 */
export const RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings = (
  postData: ClaimCustomerListingsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ClaimCustomerListingsRequestDto, ClaimCustomerListingsResponseDto>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_claimCustomerListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany_Path =
  '/api/web/v1/users/adManagement/feedCompany/claimFeedCompany';

/**
 * Claim feed company
 */
export const RentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany = (
  getParams: ClaimFeedCompanyParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ClaimFeedCompanyParams, never, ClaimFeedCompanyResponseDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_claimFeedCompany_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_Path =
  '/api/web/v1/users/adManagement/feedCompany/getAllowedFeedProvider';

/**
 * get multifamily allowed feed list
 */
export const RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider = (client = getClient()) => {
  return httpFrontEndRequest<never, never, Array<AllowedFeedDto>>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_getAllowedFeedProvider_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Path =
  '/api/web/v1/users/adManagement/listingOperations/getClaimableProperties';

/**
 * Return CompanyId claimable properties
 */
export const RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties = (
  getParams: GetClaimablePropertiesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetClaimablePropertiesParams, never, CompanyPropertyClaimingDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_getClaimableProperties_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_Path =
  '/api/web/v1/users/adManagement/listingOperations/getClaimablePropertiesFiltered';

/**
 * Return Company claimable properties which PropertyName or Address match with searchValue
 */
export const RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered = (
  getParams: GetClaimablePropertiesFilteredParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetClaimablePropertiesFilteredParams, never, CompanyPropertyClaimingDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_getClaimablePropertiesFiltered_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_Path =
  '/api/web/v1/users/adManagement/feedCompany/getClaimedFeedCompanies';

/**
 * Return claimed feed company list
 */
export const RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies = (client = getClient()) => {
  return httpFrontEndRequest<never, never, Array<CustomerClaimedFeedCompanyDto>>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_getClaimedFeedCompanies_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Path =
  '/api/web/v1/users/adManagement/customerMessage/getUserSalesProInfo';

/**
 * Return Logged User Sales Pro's Name and Email
 */
export const RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo = (client = getClient()) => {
  return httpFrontEndRequest<never, never, Array<SalesProUserInfoDto>>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_getUserSalesProInfo_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Path =
  '/api/web/v1/users/adManagement/listingOperations/releaseCustomerListings';

/**
 * Release customer Listing
 */
export const RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings = (
  postData: ReleaseCustomerListingsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, ReleaseCustomerListingsRequestDto, ReleaseCustomerListingsResponseDto>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_releaseCustomerListings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim_Path =
  '/api/web/v1/users/adManagement/feedCompany/releaseFeedCompanyClaim';

/**
 * Release feed company claim
 */
export const RentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim = (
  getParams: ReleaseFeedCompanyClaimParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ReleaseFeedCompanyClaimParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_releaseFeedCompanyClaim_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Path =
  '/api/web/v1/users/adManagement/customerMessage/sendClaimingSalesMessage';

/**
 * Sent customer message to sales pro's Email
 */
export const RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage = (
  postData: CustomerClaimingEmailMessageInfoDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CustomerClaimingEmailMessageInfoDto, void>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_sendClaimingSalesMessage_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Path =
  '/api/web/v1/users/adManagement/listingOperations/userHasNewPropertiesToClaim';

/**
 * check if user has new properties to claim
 */
export const RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim = (client = getClient()) => {
  return httpFrontEndRequest<never, never, CustomerHasNewPropertiesToClaimResponseDto>(
    {
      endpoint: RentalManagerUserClaimableListingsWebApiHandler_userHasNewPropertiesToClaim_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
